import React, { useState } from "react";
import InputText from "../utils/InputText";
import useShopStore from "../store/useShopStore";
import Button from "../utils/Button";
import classes from "./AddProduct.module.css";
import { useEffect } from "react";
import useAppStore from "../store/useAppStore";
import { toast } from "react-toastify";
export default function EditProduct() {
  const { editProduct, product } = useShopStore((state) => state);

  const [formData, setFormData] = useState({
    name: "",
    category: "",
    price: "",
    tax: "",
    description: "",
    image: "",
  });
  useEffect(() => {
    setFormData({
      name: product?.name,
      category: product?.category,
      price: product?.price,
      tax: product?.tax,
      description: product?.description,
      image: "",
    });
  }, [editProduct, product]);

  const handleChange = (event) => {
    const { name, value, files } = event.target;
    const newFormData = { ...formData };
    newFormData[name] = value;

    if (name === "image") {
      newFormData.image = files[0];
    }

    setFormData(newFormData);
  };

  const handleEditProduct = (event) => {
    // Standardverhalten abbrechen
    event.preventDefault();

    // Daten als Formular aufbereiten
    const submitForm = new FormData();
    submitForm.append("name", formData.name);
    submitForm.append("category", formData.category);
    submitForm.append("price", formData.price);
    submitForm.append("description", formData.description);
    submitForm.append("tax", formData.tax);
    // submitForm.append("image", formData.image);
    if (formData.image) submitForm.append("image", formData.image);

    editProduct(product?._id, submitForm);

    useAppStore.setState({ notify: "Product Has been Updated" });

    toast(useAppStore.getState().notify);
  };

  return (
    <form className={classes.form} onSubmit={handleEditProduct}>
      <InputText
        placeholder="Name"
        value={formData.name}
        onChange={handleChange}
        type="text"
        name="name"
      />
      <InputText
        placeholder="Category"
        value={formData.category}
        onChange={handleChange}
        type="text"
        name="category"
      />
      <InputText
        placeholder="Description"
        value={formData.description}
        onChange={handleChange}
        type="text"
        name="description"
      />
      <InputText
        placeholder="Price"
        value={formData.price}
        onChange={handleChange}
        type="number"
        name="price"
      />
      <InputText
        placeholder="Tax"
        value={formData.tax}
        onChange={handleChange}
        type="number"
        name="tax"
      />
      <InputText onChange={handleChange} type="file" name="image" />
      <Button type="submit" onSubmit={handleEditProduct}>
        Update
      </Button>
    </form>
  );
}
